<template>
    <div class="d-none d-md-block" >
        <div class="btn btn-default btn-md float-right" v-on:click=" showForm =  !showForm"><i class="fas fa-globe-americas"></i></div>
        <div class="row"v-if="showForm" style="">

            <form  class="form-group border d-flex ml-0">
                <div class="checkboxTags" v-for="item in langs">
                    <div class="pr-2  border-0 list-group-item">
                        <label class="checkbox-label" >
                           <input type="checkbox" v-model="itemValues" :value="item" v-on:change="setLang( item )" /> {{item}}
                           <div class="checkbox-check"></div>
                       </label>
                   </div>
               </div>
           </form>

       </div>
   </div>
</template>

<script>
	export default {
        data() {
          return {
            showForm: false,
            // langs: [],
            itemValues: [],
        }
    },
    props: [
    'blockid',
    'viewablecountry',
    'availableLanguages'
    ],
    mounted: function() {
        var vm = this;
        setTimeout(function() {
        vm.setValues();
        }, 10);
    },
    methods: {
        setValues() {
            this.langs = JSON.parse( this.availableLanguages )
           // "UK",
           // "NL",
           // "US",
           // "CA",
           // "IT"
           // ];

           var selection = JSON.parse( this.viewablecountry );
           if( selection ) this.itemValues = selection['permissions']

       },
       setLang(lang) {

        // console.log( this.itemValues );

        var lang = lang;
        var value = this.itemValues[lang];
        console.log( this.itemValues, this.blockid );

        let formData = new FormData();
        formData.append('values',  this.itemValues);

        axios.post( '/manage/block/setlang/'+this.blockid, formData )
        .then(function(data) {
            console.log(data);
        }.bind(this)).catch(function(data) {
            console.log('error', data);
            alert('f');
        });

    }
}
}
</script>


// WEBPACK FOOTER //
// resources/js/components/LangConfigForm.vue